import { render, staticRenderFns } from "./BiddingList.vue?vue&type=template&id=4a4cd08e"
import script from "./BiddingList.vue?vue&type=script&lang=js"
export * from "./BiddingList.vue?vue&type=script&lang=js"
import style0 from "./BiddingList.vue?vue&type=style&index=0&id=4a4cd08e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports